import {t} from "i18next";
import InfoTooltip from "../InfoTooltip";

function InsuranceTooltip({type}) {
    const allowedTypes = ["sport", "adventure"];
    if (!allowedTypes.includes(type)) return null;

    const levels = t(`generic.tooltips.insurance.${type}.levels`, {
        returnObjects: true
    });

    return (
        <InfoTooltip
            text={
                <>
                    <p>{t(`generic.tooltips.insurance.${type}.title`)}</p>
                    <ul>
                        {levels.map((item, i) => <li key={i}>{item}</li>)}
                    </ul>
                    <p>{t(`generic.tooltips.insurance.footer`)}</p>
                </>
            }
        />
    )
}

export default InsuranceTooltip;